<template>
  
  <button
      :disabled="disable"
      class="flex justify-center items-center rounded-lg gap-3 cursor-pointer border-none  relative "
      :class="[disable ? 'bg-gray-700 border-transparent' :
             fill ? 'bg-secondary border-transparent ' : (color ? (bgColor ? (noBorder ? ' border-transparent ' : ' border-(1 solid secondary) ') : '  !bg-white border-(1 solid secondary) ') : 'bg-secondary border-transparent '),
             disable ? 'opacity-100 cursor-not-allowed ' : '' ,
             mini ? 'px-4 py-2 ' : 'py-2.5 px-10 min-h-[47px] min-w-[147px] ']"
      :style="{
      borderColor: !fill && color && !noBorder ? color : '',
      borderWidth: !fill && color && !noBorder ? '0.5px' : '',
      backgroundColor: !fill && bgColor && !disable ? bgColor : (fill && color && !disable ? color : ''),
      cursor: disable ? 'not-allowed' : 'pointer'
    }"> <!-- Apply dynamic border color and background color -->

    <!-- Display icon or loading spinner if 'icon' or 'loading' is true -->
    <LazyTheNuxtIcon
        v-if="icon || loading"
        :name="loading ? 'Loading' : icon"
        icon-type="svg"
        class="text-lg"
        :class="mini ? 'px-4 py-2 ' : ''"
        :style="{ color: disable ? '#9ca3af' : fill ? 'white' : color ? color : '#1e1e1e' }"/>
    <!-- Apply dynamic icon color -->

    <!-- Displays button label text, hides when loading -->
    <p
        class="  whitespace-nowrap" :class="mini?'text-sm':'text-base'"
        :style="{ color: disable ? '#9ca3af' : fill ? 'white' : color ? color : '#1e1e1e' }">
      <!-- Apply dynamic text color -->
      {{ loading ? '' : label }} <!-- Shows label unless loading is true -->
    </p>

    <!-- Displays badge if 'badge' is greater than 0 -->
    <span
        v-show="badge"
        class="bg-secondary-500 rounded-1/2 absolute w-3 h-3 left-0 top-0 transform -translate-x-1/3 -translate-y-1/3 shadow-2xl"/>
    <!-- Position and style for the badge -->
  </button>
</template>

<script setup>
defineProps({
  fill: {
    type: Boolean,
    default: true
  },  // 'fill' defines if button is filled or outlined
  icon: {
    type: String,
  },  // 'icon' sets the icon name for the button
  label: {
    type: String,
    required: true
  },  // 'label' sets the button text (required)
  disable: {
    type: Boolean,
    default: false
  },  // 'disable' disables button when true
  mini: {
    type: Boolean,
    default: false
  },  // 'mini' controls button size, making it smaller if true
  color: {
    type: String,
  },  // 'color' sets button border and text color
  bgColor: {
    type: String,
  },  // 'bgColor' overrides the white background of an outlined button
  badge: {
    type: Number,
    default: 0
  },  // 'badge' shows a small indicator on the button if greater than 0
  loading: {
    type: Boolean,
    default: false
  },  // 'loading' adds a loading state with spinner if true
  noBorder: {
    type: Boolean,
    default: false
  }  // 'noBorder' removes the outline border on an outlined (fill=false) button without affecting other usages
})
</script>


